export const USERS_URL = "/users"
export const COMPANIES_URL = "/items"

export const rulesLanguagesRu = ['by','ru', 'kz','ua']
export const rulesLanguagesRo = ['md', 'ro']